/**
 * A/B Test — PDP gallery default slide (2nd media = Aerless Vacuum Kit video)
 * Toggle: body[data-gallery-vacuum-video-ab="true|false"]
 *   - false (Control / Test A): normal gallery on all devices
 *   - true  (Variant / Test B): vacuum kit video on first load on MOBILE only;
 *             desktop keeps normal gallery; variant change updates image on all devices
 *
 * Mobile breakpoint matches theme md-max (max-width: 999px).
 */
(function () {
  'use strict';

  var ATTR = 'data-gallery-vacuum-video-ab';
  var MOBILE_MQ = '(max-width: 999px)';
  var VACUUM_VIDEO_INDEX = 1;
  var FIRST_SLIDE_INDEX = 0;
  var applyTimer = null;
  var resizeTimer = null;
  var booted = false;
  var userChangedVariant = false;
  var initialDefaultApplied = false;

  function isAbEnabled() {
    return document.body.getAttribute(ATTR) === 'true' ||
      document.documentElement.getAttribute(ATTR) === 'true';
  }

  function isMobileGalleryView() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function isVacuumKitPdp() {
    return document.querySelector('product-gallery[data-gallery-vacuum-kit-pdp="true"]') !== null;
  }

  function hasBundleSelector() {
    return document.querySelector('.product-bundle-upsell [data-bundle-config]') !== null;
  }

  function shouldApply() {
    if (!isAbEnabled()) return false;
    if (!isMobileGalleryView()) return false;
    return isVacuumKitPdp() || hasBundleSelector();
  }

  function canApplyDefault() {
    return shouldApply() && !userChangedVariant && !initialDefaultApplied;
  }

  function getCarousels() {
    return Array.prototype.slice.call(
      document.querySelectorAll('product-gallery media-carousel')
    );
  }

  function getGalleryPageDots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('product-gallery page-dots[aria-controls]')
    );
  }

  function syncPageDots(index) {
    getGalleryPageDots().forEach(function (pageDots) {
      if (typeof pageDots.select === 'function') {
        pageDots.select(index, false);
      } else {
        Array.prototype.forEach.call(pageDots.children, function (btn, i) {
          btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
    });
  }

  function syncSlideClasses(index) {
    getCarousels().forEach(function (carousel) {
      if (!carousel.items) return;
      carousel.items.forEach(function (slide, i) {
        slide.classList.toggle('is-selected', i === index);
      });
    });
  }

  function findVacuumVideoIndex(carousel) {
    if (!carousel || !carousel.items) return VACUUM_VIDEO_INDEX;

    var visibleVideoIndex = -1;
    var secondVisibleIndex = -1;
    var visibleCount = 0;

    carousel.items.forEach(function (slide, i) {
      if (slide.hasAttribute('hidden')) return;
      if (visibleCount === 1) secondVisibleIndex = i;
      visibleCount += 1;
      var type = slide.getAttribute('data-media-type');
      if (type === 'video' || type === 'external_video') {
        visibleVideoIndex = i;
      }
    });

    if (visibleVideoIndex >= 0) return visibleVideoIndex;
    if (secondVisibleIndex >= 0) return secondVisibleIndex;
    return VACUUM_VIDEO_INDEX;
  }

  function selectGalleryIndex(index, animate) {
    if (!isMobileGalleryView()) return false;

    var carousels = getCarousels();
    if (!carousels.length) return false;

    var applied = false;
    carousels.forEach(function (carousel) {
      var targetIndex = index;
      if (isVacuumKitPdp()) {
        targetIndex = findVacuumVideoIndex(carousel);
      }

      if (!carousel.items || carousel.items.length <= targetIndex) return;
      if (carousel.items[targetIndex].hasAttribute('hidden')) return;

      try {
        carousel.select(targetIndex, { animate: animate === true, force: true });
      } catch (e) {
        carousel._selectedIndex = targetIndex;
      }
      applied = true;
      syncSlideClasses(targetIndex);
      syncPageDots(targetIndex);
    });

    return applied;
  }

  function getSelectedBundleOption() {
    var selectedCard = document.querySelector(
      '.product-bundle-upsell__card.is-selected[data-bundle-option]'
    );
    return selectedCard ? selectedCard.getAttribute('data-bundle-option') : null;
  }

  function getTargetIndex() {
    if (isVacuumKitPdp()) {
      var carousel = getCarousels()[0];
      return findVacuumVideoIndex(carousel);
    }

    var bundleOption = getSelectedBundleOption();
    if (bundleOption === 'single') return FIRST_SLIDE_INDEX;
    if (bundleOption === 'overpacker') return VACUUM_VIDEO_INDEX;
    return VACUUM_VIDEO_INDEX;
  }

  function applyGalleryDefault(retry) {
    if (!canApplyDefault()) return;

    var index = getTargetIndex();
    var applied = selectGalleryIndex(index, false);

    if (applied) {
      initialDefaultApplied = true;
      return;
    }

    if (retry < 15) {
      window.setTimeout(function () {
        applyGalleryDefault(retry + 1);
      }, 150);
    }
  }

  function scheduleApply() {
    if (!canApplyDefault()) return;
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(function () {
      applyGalleryDefault(0);
    }, 0);
  }

  function onBundleOptionInteraction(event) {
    if (!shouldApply()) return;
    var card = event.target.closest('[data-bundle-option]');
    if (!card) return;
    if (!isVacuumKitPdp() && hasBundleSelector()) {
      var index = card.getAttribute('data-bundle-option') === 'single'
        ? FIRST_SLIDE_INDEX
        : VACUUM_VIDEO_INDEX;
      selectGalleryIndex(index, false);
    }
  }

  function markUserVariantChange() {
    userChangedVariant = true;
  }

  function onViewportChange() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      if (!isAbEnabled()) return;
      if (isMobileGalleryView() && !userChangedVariant && !initialDefaultApplied) {
        scheduleApply();
      }
    }, 200);
  }

  function boot() {
    if (booted) {
      scheduleApply();
      return;
    }
    booted = true;

    scheduleApply();

    window.addEventListener('resize', onViewportChange);
    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE_MQ);
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onViewportChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onViewportChange);
      }
    }

    document.addEventListener('click', onBundleOptionInteraction);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      onBundleOptionInteraction(event);
    });

    document.addEventListener('bundle-selector:activate', scheduleApply);

    document.addEventListener('change', function (event) {
      if (!event.target) return;
      if (
        event.target.matches(
          '.product-info__variant-picker input, variant-picker input, .variant-picker input, .product-info__variant-picker select, variant-picker select'
        )
      ) {
        markUserVariantChange();
      }
    });

    document.addEventListener('click', function (event) {
      if (!event.target) return;
      if (
        event.target.closest(
          '.product-info__variant-picker, variant-picker, .variant-picker, [data-option-selector]'
        )
      ) {
        markUserVariantChange();
      }
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== ATTR) return;
        if (isAbEnabled() && !userChangedVariant) {
          initialDefaultApplied = false;
          scheduleApply();
        }
      });
    }).observe(document.body, { attributes: true, attributeFilter: [ATTR] });
  }

  function init() {
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('media-carousel').then(boot).catch(boot);
    } else {
      boot();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AerlessGalleryVacuumVideoAb = {
    isEnabled: isAbEnabled,
    isMobile: isMobileGalleryView,
    apply: function () {
      if (!isAbEnabled() || !isMobileGalleryView()) return;
      initialDefaultApplied = false;
      userChangedVariant = false;
      applyGalleryDefault(0);
    }
  };
})();
